import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7940c9f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "apply" }

import { getComponentUiText } from "@/utils/utilities";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'suggestionButton',
  props: {
  value: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  cssStyle: {
    type: String,
    default: "",
  },
},
  emits: ["onClicked"],
  setup(__props, { emit }) {

const wrapper = ref();





const maxWidth = ref(0);

onMounted(() => {
  setTimeout(() => {
    maxWidth.value = wrapper.value?.clientWidth;
  }, 10);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "wrapper",
    ref: wrapper,
    class: _normalizeClass(`${__props.cssStyle} tw-flex tw-items-center tw-gap-[5px] tw-h-[20px] tw-cursor-pointer tw-rounded-[4px] tw-px-[5px] tw-py-[3px] tw-text-[#FE9A05] tw-text-[11px] tw-not-italic tw-font-medium tw-leading-[130%] wrapper`),
    style: _normalizeStyle({
      minWidth: maxWidth.value + 'px',
    }),
    "data-cy": "suggestion-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onClicked', __props.value)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(getComponentUiText)("app-component-suggestion-button-title-suggested-1")) + _toDisplayString(__props.value ? ` - ${__props.label ? __props.label : __props.value}%` : ""), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-component-suggestion-button-title-apply-1")), 1)
  ], 6))
}
}

})